import { acceptTC } from '../../../../../../common/api/profile'

const acceptTc = () => ({
  requestPrefix: 'ACCEPT_TC:SEND',
  request: () => acceptTC()
})

export { acceptTc }
